import { useEffect, useState } from "react";

type VisualViewportFrame = {
  height: number;
  left: number;
  top: number;
  width: number;
};

const readVisualViewport = (): VisualViewportFrame => {
  const viewport = window.visualViewport;
  return {
    width: viewport?.width ?? window.innerWidth,
    height: viewport?.height ?? window.innerHeight,
    left: viewport?.offsetLeft ?? 0,
    top: viewport?.offsetTop ?? 0,
  };
};

export const useVisualViewportFrame = (enabled = true) => {
  const [frame, setFrame] = useState<VisualViewportFrame>(readVisualViewport);

  useEffect(() => {
    if (!enabled || !window.visualViewport) {
      return;
    }

    const update = () => setFrame(readVisualViewport());
    const viewport = window.visualViewport;
    viewport.addEventListener("resize", update);
    viewport.addEventListener("scroll", update);
    update();

    return () => {
      viewport.removeEventListener("resize", update);
      viewport.removeEventListener("scroll", update);
    };
  }, [enabled]);

  return {
    ...frame,
    style: {
      position: "fixed" as const,
      top: frame.top,
      left: frame.left,
      width: frame.width,
      height: frame.height,
    },
  };
};
